module.exports = __webpack_public_path__ + "static/media/cxj_banner_four.52cb7fd0.png";